import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import "../styles/Navbar.css";

const NAV_ITEMS = [
  { path: "/", label: "முகப்பு" },
  { path: "/about", label: "எங்களை பற்றி" },
  { path: "/stalldetails", label: "அரங்க விவரம்" },
  { path: "/venue", label: "இடம் & நேரம்" },
  { path: "/highlights", label: "சிறப்பம்சங்கள்" },
  { path: "/videos", label: "வீடியோக்கள்" },
  { path: "/contact", label: "தொடர்பிக்க" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navRef = useRef(null);
  const indicatorRef = useRef(null);
  const linkRefs = useRef({});

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    const activeEl = linkRefs.current[location.pathname];
    const indicator = indicatorRef.current;
    if (activeEl && indicator && window.innerWidth > 768) {
      indicator.style.width = `${activeEl.offsetWidth}px`;
      indicator.style.left = `${activeEl.offsetLeft}px`;
      indicator.style.opacity = "1";
    } else if (indicator) {
      indicator.style.opacity = "0";
    }
  }, [location.pathname, menuOpen]);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const isActive = (path) => location.pathname === path;

  return (
    <nav ref={navRef} className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        <a href="/" className="navbar-brand">
          <img
            src="https://makalukkaga.mpeoplesnet.com/imagesebf/mainlogo.png"
            className="logo"
            alt="Logo"
          />
        </a>

        <ul className="nav-links">
          <span ref={indicatorRef} className="nav-indicator" />
          {NAV_ITEMS.map((item) => (
            <li key={item.path}>
              <a
                ref={(el) => (linkRefs.current[item.path] = el)}
                href={item.path}
                className={isActive(item.path) ? "active" : ""}
                data-text={item.label}
              >
                <span className="link-label">{item.label}</span>
              </a>
            </li>
          ))}
        </ul>

        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`mobile-overlay ${menuOpen ? "open" : ""}`}>
        <ul className="mobile-links">
          {NAV_ITEMS.map((item, i) => (
            <li
              key={item.path}
              style={{ transitionDelay: menuOpen ? `${i * 0.06 + 0.1}s` : "0s" }}
            >
              <a
                href={item.path}
                className={isActive(item.path) ? "active" : ""}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;